import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ModalModule, TabsModule } from "ngx-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";

import { ScheduleJobMatchItemComponent } from './schedule-job-match-item.component';
import { ScheduleJobMatchItemActionsModalComponent } from "./schedule-job-match-item-actions-modal/schedule-job-match-item-actions-modal.component";
import { ExternalNotesModule } from "../../external-notes/external-notes.module";
import { FourDotFivePhoneNumberModule } from "../../four-dot-five-phone-number/four-dot-five-phone-number.module";
import { AddEditEmployeeModule } from "src/app/pages/mission-control-page/employee-management-page/add-edit-employee/add-edit-employee.module";
import { AiAssistantModule } from "../../ai-assistant/ai-assistant.module";
@NgModule({
    declarations: [
        ScheduleJobMatchItemComponent,
        ScheduleJobMatchItemActionsModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ExternalNotesModule,
        FourDotFivePhoneNumberModule,
        AddEditEmployeeModule,
        AiAssistantModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        NgSelectModule,
        TagInputModule
    ],
    exports: [
        ScheduleJobMatchItemComponent,
        ScheduleJobMatchItemActionsModalComponent
    ],
    entryComponents: [
        ScheduleJobMatchItemComponent,
        ScheduleJobMatchItemActionsModalComponent
    ]
})

export class ScheduleJobMatchItemModule { }
